var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wrapper", attrs: { id: "login" } }, [
    _c("div", { staticClass: "login-content d-flex justify-content-center" }, [
      _c(
        "div",
        { staticClass: "inner d-flex flex-column justify-content-between" },
        [
          _c("img", {
            staticClass: "branding",
            attrs: { src: "/static/als-logo.png", al: "ALS Logo" }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "login-form" }, [
            _c("h2", [_vm._v("Password reset")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "We've sent you an email with a link to reset your password."
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-success btn-block",
                  attrs: { type: "button", id: "backtologinButton" },
                  on: { click: _vm.backToLogin }
                },
                [_vm._v("Back to login page")]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "copyright-footer" }, [
            _vm._v("© 2024 Analytica Laboratories Limited T/A ALS NZ")
          ])
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "login-image" })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-16293040", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16293040","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ResetPassword.vue
// module id = RR07
// module chunks = 1